import Empty from './empty.tsx';
export const Worktable = Empty;
export const GlobalSearchIndex = Empty;
export const EnterpriseSetting = Empty;
export const KeyboardModel = Empty;
export const Apps = Empty;
export const CalenderIcon = Empty;
export const ContactIcon = Empty;
export const AppsIcon = Empty;
export const DiskTabIcon = Empty;
export const IMIcon = Empty;
export const MailBoxIcon = Empty;
export const BigDataIcon = Empty;
export const IntelliMarketingIcon = Empty;
export const CustomerIcon = Empty;
export const BusinessIcon = Empty;
export const WorktableIcon = Empty;
export const EnterpriseIcon = Empty;
export const SiteIcon = Empty;
export const Notice = Empty;
export const GlobalAdvertNotification = Empty;
export const NpsVpnSurvey = Empty;
export const NpsLinkedIn = Empty;
export const NpsSurvey = Empty;
export const FloatButtonRoot = Empty;
export const HelpCenter = Empty;
export const CommonSidebar = Empty;
export const Labels = { zh: {}, en: {}, zhTrad: {} };
export const WaimaoLabels = { zh: {}, en: {}, zhTrad: {} };
export const NewTamplateModal = Empty;
export const NewTemplateModal = Empty;
export const UnitableCrm = Empty;
export const UsageGuide = Empty;
export const MailSidebar = Empty;
export const ClueSidebar = Empty;
export const AddToCustomerOrClue = Empty;
export const MarketingModalList = Empty;
export const TaskList = Empty;
export const DetailUserInfo = Empty;
export const useConnectNotifySSE = () => {
    return { doConnectSSE: () => { } };
};
export const Container = Empty;
export const RenderMailto = Empty;
export const SUGGEST_MODAL = 'SuggestModal';
export const UnitableCrmLinghang = Empty;
export const CustomerManagementSetting = Empty;
export const Guide = Empty;
export const GuideType = {};
export const EdmDetail = {};
export const CompanyDetail = {};
export const useSnsIm = () => { };
export const InsertVariablModal = Empty;
export const TemplateListV2 = Empty;
export const SendedMarketing = Empty;
export const ContentEditor = Empty;
export const ProductPreviewModal = Empty;
export const ProductSampleModal = Empty;
export const ProductSettingModal = Empty;
export const LandingPageModal = Empty;
export const SensitiveTip = Empty;
export const ProductTip = Empty;
export const allMenus = {};
export const AiAssiBallEntry = Empty;
export const useChatDrawerController = () => { };
export const ChatDrawer = Empty;
export const useShowAiAssistant = () => false;
export const SALES_PITCH_GUIDE_ID = 'SALES_PITCH_GUIDE_ID';
export const EmailContentAssistantComponent = Empty;
export const CrmBase = Empty;
